import { render, staticRenderFns } from "./AddSpares.vue?vue&type=template&id=74c81966&scoped=true"
import script from "./AddSpares.vue?vue&type=script&lang=js"
export * from "./AddSpares.vue?vue&type=script&lang=js"
import style0 from "./AddSpares.vue?vue&type=style&index=0&id=74c81966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c81966",
  null
  
)

export default component.exports